<span class="dialog-close" (click)="dialogclose()"><!-- <i class="material-icons" >close</i>--> <img src="assets/icons/close-drawer.svg" alt="" /></span>
<class-detail [programId]="programId" [classId]="classId" [facilitatorAttendance]="facilitatorAttendance" 
(indexSelected)="onIndexSelected($event)"
(isAnyClockFormOpen)="onClockSelected($event)"
></class-detail>